export default {
    template: '#canvas_generator',
    created: function () {
        var that = this;
        this.$on('canvas-changed', _.debounce(function (callback) {
            // that.createDesign(that.side, null);
            that.createDesign(that.side, 5, callback);
        }, 200));
    },
    props: ['side'],
    data: function () {
        return {
            canvas_id: '',
            product_canvas_id: '',
            quality_canvas_id: ''
        };
    },
    methods: {
        getId: function (side) {
            var canvas_id = "design_" + side;
            this.$set('canvas_id', canvas_id);
            return canvas_id;
        },
        getProductId: function (side) {
            var product_canvas_id = "product_design_" + side;
            this.$set('product_canvas_id', product_canvas_id);
            return product_canvas_id;
        },
        getHighQualityDesignId: function (side) {
            var quality_design_canvas_id = "quality_design_" + side;
            this.$set('quality_canvas_id', quality_design_canvas_id);
            return quality_design_canvas_id;
        },
        createDesign: function (side, multiplier, callback) {
            var items = (side == 'front' ? this.$root.designerItems.front : this.$root.designerItems.back);
            if (multiplier == null) multiplier = 1;
            this.drawDesign(items, side, multiplier, callback);
        },
        drawDesign: function (items, side, multiplier, callback) {
            var obj = [],
                area = this.$root.selectedProduct.dimensions[side].offsets,
                self = this;

            _.forEach(items, function (item, j) {
                obj[j] = {};
                obj[j].top = item.span.top * multiplier;
                obj[j].left = item.span.left * multiplier;
                obj[j].width = item.span.width * multiplier;
                obj[j].height = item.span.height * multiplier;
                obj[j].rotate = item.rotate;
                obj[j].letterSpacing = parseInt(item.element.stroke_width || 0) || 0;

                // var rotatedPosition = that.$root.getRotatedPosition(obj[j].left, pTop, oLeft, oTop, angle)

                var svg = item.type == "ARTWORK" ? $('#' + item.id).find('svg:eq(0)') : $('#' + item.id).find('svg'),
                    svgClone = $(svg).clone();
                var svgWidth = $(svg).width(),
                    svgHeight = $(svg).height();

                $(svgClone).width(svgWidth * multiplier);
                $(svgClone).height(svgHeight * multiplier);

                var image = $(svg).find('image'),
                    cloneImage = $(svgClone).find('image');
                if (typeof image[0] == 'undefined') {
                    obj[j].img = false;
                } else {
                    obj[j].img = true;
                    var imageWidth = $(image).attr('width'),
                        imageHeight = $(image).attr('height');
                    $(cloneImage).attr('width', imageWidth * multiplier);
                    $(cloneImage).attr('height', imageHeight * multiplier);

                    if (multiplier > 1) {
                        $(cloneImage).attr('xlink:href', item.imageData.original_encoded);
                    } else {
                        $(cloneImage).attr('xlink:href', item.imageData.thumbnail_encoded);
                    }
                    obj[j].src = (multiplier > 1 ? item.imageData.original_encoded : item.imageData.thumbnail_encoded);
                }

                obj[j].svg = $('<div></div>').html(svgClone).html();
                obj[j].zIndex = item.span.index;
                j++;
            });

            //Moving this here, because the canvas needs to be cleared irrespective of if a item exists on the side or not
            var canvas = document.getElementById(multiplier == 1 ? this.canvas_id : this.quality_canvas_id);
            canvas.width = self.$root.getDesignerHelper().px(area.width) * multiplier;
            canvas.height = self.$root.getDesignerHelper().px(area.height) * multiplier;
            var context = canvas.getContext('2d', {preserveDrawingBuffer: false});

            context.clearRect(0, 0, canvas.width, canvas.height);

            if (obj.length > 0) {
                obj.sort(function (obj1, obj2) {
                    return obj1.zIndex - obj2.zIndex;
                });

                var radius = 0;

                let canvasLoad = function canvasLoad(obj, i) {
                    if (typeof obj[i] != 'undefined') {
                        var IE = /msie/.test(navigator.userAgent.toLowerCase());
                        var item = obj[i];
                        i++;
                        if (IE === true) {
                            item.svg = item.svg.replace(' xmlns:NS1=""', '');
                            item.svg = item.svg.replace(' NS1:xmlns:xlink="http://www.w3.org/1999/xlink"', '');
                            item.svg = item.svg.replace(' xmlns="http://www.w3.org/2000/svg"', '');
                        }

                        if (radius > 0) {
                            context.save();
                            var x = 0,
                                y = 0;
                            var w = self.$root.getDesignerHelper().px(area.width) * multiplier;
                            var h = self.$root.getDesignerHelper().px(area.height) * multiplier;
                            var r = x + w;
                            var b = y + h;

                            context.beginPath();
                            context.moveTo(x + radius, y);
                            context.lineTo(r - radius, y);
                            context.quadraticCurveTo(r, y, r, y + radius);
                            context.lineTo(r, y + h - radius);
                            context.quadraticCurveTo(r, b, r - radius, b);
                            context.lineTo(x + radius, b);
                            context.quadraticCurveTo(x, b, x, b - radius);
                            context.lineTo(x, y + radius);
                            context.quadraticCurveTo(x, y, x + radius, y);
                            context.closePath();
                            context.clip();
                        }

                        if (item.rotate != 0) {
                            context.save();
                            context.translate(item.left, item.top);
                            context.translate(item.width / 2, item.height / 2);
                            context.rotate(self.$root.getDesignerHelper().radDeg(item.rotate) * Math.PI / 180);
                            item.left = (item.width / 2) * -1;
                            item.top = (item.height / 2) * -1;
                        }

                        try {
                            if (item.img === true) {
                                var images = new Image();
                                if (is.safari())
                                    images.crossOrigin = null;
                                else
                                    images.crossOrigin = 'Anonymous';
                                images.onload = function () {
                                    context.drawImage(images, item.left, item.top, item.width, item.height);
                                    context.restore();
                                    canvasLoad(obj, i);
                                };
                                images.src = item.src;
                            }
                            else {
                                canvas.style.letterSpacing = `${item.letterSpacing}px`;
                                context = canvas.getContext('2d');

                                if (item.letterSpacing) {
                                    let matches = item.svg.match(/viewBox="(.+?)"/),
                                      viewBox = matches[1].split(','),
                                      halfLetterSpacing = item.letterSpacing / 2;

                                    viewBox[0] = (parseFloat(viewBox[0]) + halfLetterSpacing) - (halfLetterSpacing * multiplier);
                                    viewBox[1] = (parseFloat(viewBox[1]) + halfLetterSpacing) - (halfLetterSpacing * multiplier);
                                    viewBox[2] = (parseFloat(viewBox[2]) - item.letterSpacing) + (item.letterSpacing * multiplier);
                                    // viewBox[3] = (parseFloat(viewBox[3]) - halfLetterSpacing) + (halfLetterSpacing * multiplier);

                                    item.svg = item.svg.replace(/viewBox=".+?"/, `viewBox="${viewBox.join(',')}"`);
                                }

                                context.drawSvg(item.svg, item.left, item.top);
                                context.restore();
                                canvasLoad(obj, i);
                            }
                        } catch (e) {
                            console.log('Exception', e);
                            if (e.name == "NS_ERROR_NOT_AVAILABLE") {
                            }
                        }
                    } else {
                        if (callback)
                            callback();
                    }
                }

                canvasLoad(obj, 0);

                return canvas;
            }
        }
    }
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/designer_tab/controls/canvasGenerator.js